import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiAction } from "../../../api/ApiAction";
import { endpoints } from "../../../api/endpoints";
import { IResortExtended } from "../../../api/types/directory/IResort";
import { AppDispatch } from "../../appDispatch";
import { RootState } from "../../rootState";
import { IAssociateParams } from "./types/IAssociateParams";

export const fetchAssociateResorts = createAsyncThunk<
  IResortExtended[],
  IAssociateParams,
  { state: RootState; dispatch: AppDispatch }
>("associate/fetchResorts", async (params, thunkAPI) => {
  const result = await endpoints.directory.get(
    {
      action: ApiAction.getResorts,
      operator: params.operator,
      country: params.country,
    },
    thunkAPI.signal,
  );

  return result as IResortExtended[];
});
